import React  from 'react';
import { List, Segment, Divider, Table, Grid, Image, Header, Icon, Accordion,Progress, Popup, Container, Label} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';


const Modulos=({ id, margenes, onVisible, modulos, onAcordionModulo, olor, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, showModalComents, handleClick, fechaActual, fechaComentario, titulo, allowAccess})=>{

    	return (
        <Segment>
        
        {modulos.map(modulo =>
            <div>
            
                <Segment ribbon style={{ background: "#B8D8D5"}} >
                       <Grid>
                            <Grid.Row columns="2" >
                            <Grid.Column width="13"  only='computer tablet '>
                                <Label as='a' onClick={()=>onAcordionModulo(modulo.id)} color='teal' ribbon size="big">
                                  {modulo.titulo}
                                </Label>    

                                <br/><br/>

                                <Header as='h5' floated='left'>
                                    {modulo.descripcion}
                                    <Header.Subheader>
                                        {modulo.contenido.length} actividades
                                    </Header.Subheader>
                                </Header>

                            </Grid.Column>

                            <Grid.Column width="13"  only='mobile'>
                                <Label as='a' onClick={()=>onAcordionModulo(modulo.id)} color='teal' ribbon size="medium">
                                  {modulo.titulo}
                                </Label>    

                                <br/><br/>

                                <Header  floated='left'>
                                    {modulo.descripcion}
                                    <Header.Subheader>
                                        {modulo.contenido.length} actividades
                                    </Header.Subheader>
                                </Header>

                            </Grid.Column>               
                            <Grid.Column width="3" textAlign='right' verticalAlign="middle">
                                <Icon size="large" color={modulo.activo?"grey":"teal"}  name={modulo.activo?"minus":"plus"} link onClick={()=>onAcordionModulo(modulo.id)}/>
                            </Grid.Column>

                        </Grid.Row>
                     </Grid>
                </Segment>
        
        

        
        
                {modulo.activo?
                <Segment basic >

                {modulo.contenidoView.map(rowView =>
                <Segment.Group >
                      <Segment basic ribbon style={{ background: "#E7F0EF"}}>

                            <Grid>
                            <Grid.Row >
                            <Grid.Column only='computer tablet '>

                                <Label as='a'   ribbon style={{ background: "#B8D8D5"}} size="large">
                                 {rowView.agrupador+" - "+rowView.fecha}
                                </Label>          

                            </Grid.Column>

                            <Grid.Column only='mobile'>

                                <Label as='a'   ribbon style={{ background: "#B8D8D5"}} size="small">
                                 {rowView.agrupador+" - "+rowView.fecha}
                                </Label>          

                            </Grid.Column>    

                            </Grid.Row>
                            </Grid>

                            </Segment>

                                        {rowView.contenido.map(row =>
                                              <Segment color="teal">
                                               <Grid>
                                                    <Grid.Row columns="2" >
                                                    <Grid.Column width="13">
                                                    <Header as='h4'>
                                                       
                                                        <Header.Content>
                                                        {row.titulo}        

                                                         <Header.Subheader>
                                                           {row.desc+ " "}
                                                            {row.idTipoContenido==28 && row.fechaInicioExamen!=null?
                                                                <><br/>Activo el día: {row.fechaInicioExamen.substring(0,10)} al {row.fechaTerminoExamen.substring(0,10)}</>                                    
                                                                :
                                                                ""
                                                            }


                                                        </Header.Subheader>
                                                        </Header.Content>
                                                    </Header> 

                                                    </Grid.Column>    
                                                    <Grid.Column width="3" textAlign='right'>
                                                        {row.url!=null?

                                                                <Icon size="large" color={row.color} link onClick={()=>handleClick(row.url, row.id)} name={row.icon} />

                                                            :            
                                                     
                                                                <Icon size="large" color={row.color} link onClick={()=>onVisible(row.id)} name={row.icon} />
                                                            
                                                        }
                                                </Grid.Column>

                                            </Grid.Row>


                                             



                                            </Grid>

                                            </Segment>
                                        )}	


                            </Segment.Group>
                        )}
                </Segment>:""
                }
                
                
         

            </div>
        )}	
    
        
     
        </Segment>
	);
};



export default Modulos;